export default __webpack_public_path__ + "static/media/coinOne.04662ee0.png";